"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import r from "../components/Icon/SvgIcon.js";
const t = (e) => /* @__PURE__ */ o(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.035 11.518a2.518 2.518 0 1 1-5.035 0 2.518 2.518 0 0 1 5.035 0m7.483 0a2.518 2.518 0 1 1-5.036 0 2.518 2.518 0 0 1 5.036 0m4.964 2.517a2.517 2.517 0 1 0 0-5.035 2.517 2.517 0 0 0 0 5.035",
        clipRule: "evenodd"
      }
    )
  }
), n = l(t);
export {
  n as MoreFilled,
  n as default
};
